export default "__VITE_ASSET__BtaNaGYA__"